import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons/index';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome/index';
import Header from "../Units/Header";
import OptionRow from '../Profile/OptionRow';
import '../../assets/stylesheets/LeaderBoard/LeaderBoard.scss'


const infoLinks = ["hints", "rewards"];

const LeaderBoardInfo = ({}) => {

    return (
            <div className={'leaderboardInfo'}>
                <Header title='leaderboardInfoTitle' backTo={'/leaderboard'} ></Header>
                <div className="leaderBoardInfoLinks">
                    {
                        infoLinks.map((option, index) => <OptionRow key={index} to={`/leaderboard/info/${option}`} option={option} section="leaderboardInfo"></OptionRow>)
                    }
                </div>
            </div>
    );
}

export default LeaderBoardInfo;
